module.exports = __webpack_public_path__ + "static/media/SF_bm_sekundaerlogo_postale_vestfold_telemark_pos.59fb8708.png";